export enum ItemStatuses {
  Pending = 'pending',
  Completed = 'completed',
  Ignored = 'ignored',
}
